// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import { Form, Button, Table } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";

// function ResultsHistory() {
//   const [results, setResults] = useState([]);
//   const [seriesList, setSeriesList] = useState([]);
//   const [selectedDate, setSelectedDate] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const apiBase = process.env.REACT_APP_SERVER_URL;
//   const navigate = useNavigate();

//   const isTimePassed = (selectedDate, slotTime) => {
//   const now = new Date();
//   const [time, modifier] = slotTime.split(' ');
//   let [hours, minutes] = time.split(':');

//   if (hours === '12') hours = '00';
//   if (modifier === 'PM') hours = parseInt(hours, 10) + 12;

//   const resultDateTime = new Date(`${selectedDate}T${hours.toString().padStart(2, '0')}:${minutes}:00`);

//   return now >= resultDateTime;
// };

// const fetchResults = async (date) => {
//   if (!date) return;

//   setLoading(true);
//   setError("");

//   const today = new Date().toISOString().split("T")[0];

//   // 🚫 Future date check
//   if (date > today) {
//     setLoading(false);
//     setResults([]);
//     setError("Results for future dates are not available yet.");
//     return;
//   }

//   // 🕒 Current time (HH:mm)
//   const now = new Date();
//   const currentTime = now.toLocaleTimeString("en-GB", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: false
//   });

//   // 📦 Payload logic
//   const payload =
//     date === today
//       ? { date, currentTime } // today → send time
//       : { date };             // past date → date only

//   try {
//     const res = await axios.post(
//       `${apiBase}/api/results/history`,
//       payload
//     );

//     setResults(res.data || []);
//   } catch (err) {
//     setResults([]);
//     if (err.response?.status === 404) {
//       setError("No results found for this date.");
//     } else {
//       setError("Failed to fetch results.");
//     }
//   } finally {
//     setLoading(false);
//   }
// };

//   const fetchSeries = async () => {
//     try {
//       const res = await axios.get(`${apiBase}/api/admin/series`); 
//       setSeriesList(res.data || []);
//     } catch (err) {
//       console.error("Failed to fetch series", err);
//     }
//   };

//   const handleFilter = () => {
//     if (selectedDate) fetchResults(selectedDate);
//   };

//   useEffect(() => {
//     const today = new Date().toISOString().split("T")[0];
//     setSelectedDate(today);
//     fetchResults(today);
//     fetchSeries();
//   }, []);

//   let groupedResults = useMemo(() => {
//   const todayStr = new Date().toISOString().split("T")[0];

//   return results.reduce((acc, curr) => {
//     const time = curr.slot;
//     if (!time) return acc;

//     // --- NEW LOGIC START ---
//     // If the selected date is today, check if the slot time has passed
//     if (selectedDate === todayStr) {
//       if (!isTimePassed(selectedDate, time)) {
//         return acc; // Skip this result if the time hasn't come yet
//       }
//     }
//     // --- NEW LOGIC END ---

//     if (!acc[time]) acc[time] = {};

//     const series = seriesList.find((s) => s.id === curr.seriesId);
//     if (series) {
//       acc[time][series.name.toLowerCase().trim()] = curr.winning_number;
//     }

//     return acc;
//   }, {});
// }, [results, seriesList]);

//   return (
//     <div
//       style={{
//         backgroundColor: "#f8f9fa",
//         minHeight: "100vh",
//         padding: "30px 20px",
//         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       }}
//     >
//       {/* Back Button */}
//       <div className="mb-4">
//         <Button
//           variant="secondary"
//           onClick={() => navigate(-1)}
//           style={{ borderRadius: "6px", padding: "6px 18px" }}
//         >
//           &larr; Back
//         </Button>
//       </div>

//       {/* Title */}
//       <h2
//         className="text-center mb-4"
//         style={{ fontWeight: "600", fontSize: "2rem", color: "#343a40" }}
//       >
//         🎯 Lottery Results
//       </h2>

//       {/* Date Filter */}
//       <div className="d-flex justify-content-center align-items-center gap-3 mb-5 flex-wrap">
//         <label
//           className="fw-bold"
//           style={{ fontSize: "1rem", color: "#495057" }}
//         >
//           Select Date:
//         </label>
//         <Form.Control
//           type="date"
//           value={selectedDate}
//           onChange={(e) => setSelectedDate(e.target.value)}
//           style={{
//             width: "200px",
//             borderRadius: "6px",
//             border: "1px solid #ced4da",
//             backgroundColor: "#fff",
//             color: "#495057",
//           }}
//         />
//         <Button
//           variant="primary"
//           onClick={handleFilter}
//           style={{ borderRadius: "6px", padding: "6px 20px", fontWeight: "500" }}
//         >
//           Submit
//         </Button>
//       </div>

//       {/* Loading / Error / Table */}
//       {loading ? (
//         <p className="text-center" style={{ fontSize: "1.1rem", color: "#6c757d" }}>
//           Loading results...
//         </p>
//       ) : error ? (
//         <div className="alert alert-danger text-center">{error}</div>
//       ) : (
//         <div className="table-responsive shadow-sm rounded">
//           <Table
//             bordered
//             className="text-center align-middle mb-0"
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "6px",
//               overflow: "hidden",
//             }}
//           >
//             <thead
//               style={{
//                 backgroundColor: "#007bff",
//                 color: "#ffffff",
//                 fontWeight: "600",
//               }}
//             >
//               <tr>
//                 <th>TIME</th>
//                 {seriesList.map((s) => (
//                   <th key={s.id}>{s.name}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {Object.keys(groupedResults).length > 0 ? (
//                 Object.entries(groupedResults)
//                   .sort(([a], [b]) => a.localeCompare(b))
//                   .map(([time, seriesData]) => (
//                     <tr key={time} style={{ transition: "background 0.3s" }}>
//                       <td className="fw-bold">{time}</td>
//                       {seriesList.map((series) => {
//                         const key = series.name.toLowerCase().trim();
//                         return (
//                           <td key={series.id} className="fw-bold">
//                             {seriesData[key] || "-"}
//                           </td>
//                         );
//                       })}
//                     </tr>
//                   ))
//               ) : (
//                 <tr>
//                   <td colSpan={seriesList.length + 1} className="text-center text-muted">
//                     No results found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </div>
//       )}
//     </div>
//   );
// }

// export default ResultsHistory;
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Form, Button, Table, Container, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function ResultsHistory() {
  const [results, setResults] = useState([]);
  const [seriesList, setSeriesList] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const apiBase = process.env.REACT_APP_SERVER_URL;
  const navigate = useNavigate();

  const isTimePassed = (selectedDate, slotTime) => {
    const now = new Date();
    const [time, modifier] = slotTime.split(' ');
    let [hours, minutes] = time.split(':');

    if (hours === '12') hours = '00';
    if (modifier === 'PM') hours = parseInt(hours, 10) + 12;

    const resultDateTime = new Date(`${selectedDate}T${hours.toString().padStart(2, '0')}:${minutes}:00`);

    return now >= resultDateTime;
  };

  const fetchResults = async (date) => {
    if (!date) return;

    setLoading(true);
    setError("");

    const today = new Date().toISOString().split("T")[0];

    // 🚫 Future date check
    if (date > today) {
      setLoading(false);
      setResults([]);
      setError("Results for future dates are not available yet.");
      return;
    }

    // 🕒 Current time (HH:mm)
    const now = new Date();
    const currentTime = now.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });

    // 📦 Payload logic
    const payload =
      date === today
        ? { date, currentTime } // today → send time
        : { date };             // past date → date only

    try {
      const res = await axios.post(
        `${apiBase}/api/results/history`,
        payload
      );

      setResults(res.data || []);
    } catch (err) {
      setResults([]);
      if (err.response?.status === 404) {
        setError("No results found for this date.");
      } else {
        setError("Failed to fetch results.");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchSeries = async () => {
    try {
      const res = await axios.get(`${apiBase}/api/admin/series`); 
      setSeriesList(res.data || []);
    } catch (err) {
      console.error("Failed to fetch series", err);
    }
  };

  const handleFilter = () => {
    if (selectedDate) fetchResults(selectedDate);
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setSelectedDate(today);
    fetchResults(today);
    fetchSeries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let groupedResults = useMemo(() => {
    const todayStr = new Date().toISOString().split("T")[0];

    return results.reduce((acc, curr) => {
      const time = curr.slot;
      if (!time) return acc;

      // If the selected date is today, check if the slot time has passed
      if (selectedDate === todayStr) {
        if (!isTimePassed(selectedDate, time)) {
          return acc; // Skip this result if the time hasn't come yet
        }
      }

      if (!acc[time]) acc[time] = {};

      const series = seriesList.find((s) => s.id === curr.seriesId);
      if (series) {
        acc[time][series.name.toLowerCase().trim()] = curr.winning_number;
      }

      return acc;
    }, {});
  }, [results, seriesList, selectedDate]);

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)", // Rich, colorful dark gradient
        minHeight: "100vh",
        padding: "40px 15px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#fff",
      }}
    >
      <Container maxWidth="lg">
        {/* Back Button */}
        <div className="mb-4">
          <Button
            variant="outline-light"
            onClick={() => navigate(-1)}
            style={{ borderRadius: "8px", padding: "8px 20px", fontWeight: "bold" }}
          >
            &larr; Back
          </Button>
        </div>

        {/* Title */}
        <h2
          className="text-center mb-4"
          style={{ fontWeight: "700", fontSize: "2.5rem", color: "#f8b500", textShadow: "2px 2px 4px rgba(0,0,0,0.3)" }}
        >
          🎯 Lottery Results
        </h2>

        {/* Date Filter - Mobile Responsive (Stacks on small screens) */}
        <Card 
          className="p-4 mb-5 mx-auto border-0 shadow" 
          style={{ 
            maxWidth: "600px", 
            backgroundColor: "rgba(255, 255, 255, 0.1)", 
            backdropFilter: "blur(10px)", 
            borderRadius: "15px" 
          }}
        >
          <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3">
            <label
              className="fw-bold mb-0"
              style={{ fontSize: "1.1rem", color: "#fff", whiteSpace: "nowrap" }}
            >
              Select Date:
            </label>
            <Form.Control
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              style={{
                maxWidth: "250px",
                borderRadius: "8px",
                border: "2px solid #4facfe",
                backgroundColor: "#fff",
                color: "#333",
                fontWeight: "500"
              }}
            />
            <Button
              variant="warning"
              onClick={handleFilter}
              className="w-100 w-sm-auto"
              style={{ 
                borderRadius: "8px", 
                padding: "8px 25px", 
                fontWeight: "700",
                color: "#0f2027"
              }}
            >
              Check
            </Button>
          </div>
        </Card>

        {/* Loading / Error / Table */}
        {loading ? (
          <div className="text-center mt-5">
            <div className="spinner-border text-warning" role="status"></div>
            <p className="mt-3 fw-bold" style={{ fontSize: "1.2rem", color: "#f8b500" }}>
              Loading your lucky numbers...
            </p>
          </div>
        ) : error ? (
          <div className="alert alert-danger text-center shadow-sm fw-bold mx-auto" style={{ maxWidth: "600px", borderRadius: "10px" }}>
            {error}
          </div>
        ) : (
          <div 
            className="shadow-lg rounded"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              borderRadius: "15px",
              overflow: "hidden",
              border: "1px solid rgba(255,255,255,0.1)"
            }}
          >
            <Table
              responsive
              hover
              variant="dark"
              className="text-center align-middle mb-0"
              style={{ minWidth: "600px" }} // Ensures the table doesn't get too squished on mobile before scrolling kicks in
            >
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#e84a5f", color: "#fff", padding: "15px", fontSize: "1.1rem" }}>
                    TIME
                  </th>
                  {seriesList.map((s) => (
                    <th key={s.id} style={{ backgroundColor: "#e84a5f", color: "#fff", padding: "15px", fontSize: "1.1rem" }}>
                      {s.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.keys(groupedResults).length > 0 ? (
                  Object.entries(groupedResults)
                    .sort(([a], [b]) => a.localeCompare(b))
                    .map(([time, seriesData]) => (
                      <tr key={time}>
                        <td className="fw-bold" style={{ color: "#4facfe", padding: "15px" }}>{time}</td>
                        {seriesList.map((series) => {
                          const key = series.name.toLowerCase().trim();
                          return (
                            <td key={series.id} className="fw-bold" style={{ fontSize: "1.1rem", padding: "15px" }}>
                              {seriesData[key] ? (
                                <span className="badge bg-success fs-6 rounded-pill px-3 py-2 shadow-sm">
                                  {seriesData[key]}
                                </span>
                              ) : (
                                <span className="text-muted">-</span>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={seriesList.length + 1} className="text-center p-5 text-light fs-5">
                      No results found for this date.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Container>
    </div>
  );
}

export default ResultsHistory;